import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/dailyneedsworld.com/httpdocs/src/app/vendor/[slug]/VendorClient.tsx");
